import { Injectable } from '@angular/core';
import { HTTPService } from 'src/app/services/http.service';
import { BehaviorSubject, Observable } from 'rxjs';

export interface IconOption {
  value: string;
  label: string;
  category: string;
  path: string;
  preview: string;
  isCustom?: boolean; // Indica se veio do MKTPICONS
}

@Injectable({
  providedIn: 'root'
})
export class IconManagerService {
  
  private readonly iconCategories = {
    'marketplace': 'Marketplaces & E-commerce',
    'utility': 'Funcionalidades & Utilitários', 
    'business': 'Empresas & Serviços',
    'generic': 'Imagens Genéricas',
    'custom': 'Ícones Customizados (MKTPICONS)' // ⭐ NOVA CATEGORIA
  };

  // ⭐ Ícones estáticos (sempre disponíveis) - DEVE VIR ANTES DE allIconsSubject
  private readonly staticIcons: IconOption[] = [
    // Marketplaces
    { value: 'amazon', label: 'Amazon', category: 'marketplace', path: 'assets/image/amazon.svg', preview: 'assets/image/amazon.svg' },
    { value: 'magalu', label: 'Magazine Luiza', category: 'marketplace', path: 'assets/image/magalu.svg', preview: 'assets/image/magalu.svg' },
    { value: 'meli', label: 'Mercado Livre', category: 'marketplace', path: 'assets/image/meli.svg', preview: 'assets/image/meli.svg' },
    { value: 'shopee', label: 'Shopee', category: 'marketplace', path: 'assets/image/shopee.svg', preview: 'assets/image/shopee.svg' },
    { value: 'shopify', label: 'Shopify', category: 'marketplace', path: 'assets/image/shopify.svg', preview: 'assets/image/shopify.svg' },
    { value: 'vtex', label: 'VTEX', category: 'marketplace', path: 'assets/image/vtex.svg', preview: 'assets/image/vtex.svg' },
    { value: 'magento', label: 'Magento', category: 'marketplace', path: 'assets/image/magento.svg', preview: 'assets/image/magento.svg' },
    { value: 'woo', label: 'WooCommerce', category: 'marketplace', path: 'assets/image/woo.svg', preview: 'assets/image/woo.svg' },
    { value: 'nuvemshop', label: 'Nuvem Shop', category: 'marketplace', path: 'assets/image/nuvemshop.svg', preview: 'assets/image/nuvemshop.svg' },
    { value: 'kabum', label: 'Kabum', category: 'marketplace', path: 'assets/image/kabum.svg', preview: 'assets/image/kabum.svg' },
    { value: 'carrefour', label: 'Carrefour', category: 'marketplace', path: 'assets/image/carrefour.svg', preview: 'assets/image/carrefour.svg' },
    { value: 'b2w', label: 'B2W', category: 'marketplace', path: 'assets/image/b2w.svg', preview: 'assets/image/b2w.svg' },
    { value: 'viavarejo', label: 'Via Varejo', category: 'marketplace', path: 'assets/image/viavarejo.svg', preview: 'assets/image/viavarejo.svg' },
    
    // Utilitários
    { value: 'database', label: 'Banco de Dados', category: 'utility', path: 'assets/image/database.svg', preview: 'assets/image/database.svg' },
    { value: 'datacopy', label: 'Copiar Dados', category: 'utility', path: 'assets/image/datacopy.svg', preview: 'assets/image/datacopy.svg' },
    { value: 'datasave', label: 'Salvar Dados', category: 'utility', path: 'assets/image/datasave.svg', preview: 'assets/image/datasave.svg' },
    { value: 'excel', label: 'Excel', category: 'utility', path: 'assets/image/excel.svg', preview: 'assets/image/excel.svg' },
    { value: 'circle-check', label: 'Verificado', category: 'utility', path: 'assets/image/circle-check.svg', preview: 'assets/image/circle-check.svg' },
    { value: 'stop', label: 'Parar', category: 'utility', path: 'assets/image/stop.svg', preview: 'assets/image/stop.svg' },
    
    // Empresas & Serviços
    { value: '6place', label: '6place', category: 'business', path: 'assets/image/6place.svg', preview: 'assets/image/6place.svg' },
    { value: 'fbits', label: 'Fbits', category: 'business', path: 'assets/image/fbits.svg', preview: 'assets/image/fbits.svg' },
    { value: 'ifood', label: 'iFood', category: 'business', path: 'assets/image/ifood.svg', preview: 'assets/image/ifood.svg' },
    { value: 'infracommerce', label: 'Infracommerce', category: 'business', path: 'assets/image/infracommerce.svg', preview: 'assets/image/infracommerce.svg' },
    { value: 'instaleap', label: 'Instaleap', category: 'business', path: 'assets/image/instaleap.svg', preview: 'assets/image/instaleap.svg' },
    { value: 'intelipost', label: 'Intelipost', category: 'business', path: 'assets/image/intelipost.svg', preview: 'assets/image/intelipost.svg' },
    { value: 'olist', label: 'Olist', category: 'business', path: 'assets/image/olist.svg', preview: 'assets/image/olist.svg' },
    { value: 'ploomes', label: 'Ploomes', category: 'business', path: 'assets/image/ploomes.svg', preview: 'assets/image/ploomes.svg' },
    { value: 'sankhya', label: 'Sankhya', category: 'business', path: 'assets/image/sankhya.svg', preview: 'assets/image/sankhya.svg' },
    { value: 'traycorp', label: 'Tray Corp', category: 'business', path: 'assets/image/traycorp.svg', preview: 'assets/image/traycorp.svg' },
    { value: 'wbuy', label: 'WBuy', category: 'business', path: 'assets/image/wbuy.svg', preview: 'assets/image/wbuy.svg' },
    
    // Genéricos
    { value: 'camera', label: 'Câmera', category: 'generic', path: 'assets/image/camera_create_icon.png', preview: 'assets/image/camera_create_icon.png' },
    { value: 'no-image', label: 'Sem Imagem', category: 'generic', path: 'assets/image/no-image-icon.png', preview: 'assets/image/no-image-icon.png' },
    { value: 'no-image-round', label: 'Sem Imagem (Redondo)', category: 'generic', path: 'assets/image/no-image-icon-round.png', preview: 'assets/image/no-image-icon-round.png' },
  ];

  // ⭐ Cache de ícones combinados (hardcoded + MKTPICONS) - DEVE VIR DEPOIS DE staticIcons
  private allIconsSubject = new BehaviorSubject<IconOption[]>(this.staticIcons);
  public allIcons$ = this.allIconsSubject.asObservable();
  private customIconsLoaded = false;

  constructor(private http: HTTPService) {
    // Carregar ícones customizados automaticamente na inicialização
    this.loadCustomIcons();
  }

  /**
   * ⭐ NOVO: Carrega ícones customizados da tabela MKTPICONS
   */
  private loadCustomIcons(): void {
    if (this.customIconsLoaded) {
      return; // Já carregou
    }

    const query = {
      entityName: 'Mktpicons',
      sql: `SELECT NAME FROM MKTPICONS ORDER BY NAME`
    };

    this.http.post(query, 'JsonBrokerServices/findnative', false, true, true)
      .subscribe({
        next: (response: any) => {
          if (response && response.SQL) {
            const customIcons: IconOption[] = response.SQL.map((icon: any) => ({
              value: `custom:${icon.NAME}`,
              label: icon.NAME,
              category: 'custom',
              path: `custom:${icon.NAME}`, // Referência ao ícone registrado no NzIconService
              preview: `custom:${icon.NAME}`, // Será renderizado via nz-icon
              isCustom: true
            }));

            // Combinar ícones estáticos + customizados
            const allIcons = [...this.staticIcons, ...customIcons];
            this.allIconsSubject.next(allIcons);
            this.customIconsLoaded = true;
            
            console.log(`✅ ${customIcons.length} ícones customizados carregados do MKTPICONS`);
          }
        },
        error: (error) => {
          console.error('❌ Erro ao carregar ícones customizados:', error);
          // Em caso de erro, usar apenas ícones estáticos
          this.allIconsSubject.next(this.staticIcons);
        }
      });
  }

  /**
   * ⭐ NOVO: Força recarregar os ícones do banco (útil para refresh manual)
   */
  public reloadCustomIcons(): void {
    this.customIconsLoaded = false;
    this.loadCustomIcons();
  }

  /**
   * Retorna todos os ícones (estáticos + customizados)
   */
  getAvailableIcons(): IconOption[] {
    return this.allIconsSubject.value;
  }

  /**
   * Retorna ícones por categoria
   */
  getIconsByCategory(category: string): IconOption[] {
    return this.allIconsSubject.value.filter(icon => icon.category === category);
  }

  /**
   * Retorna todas as categorias
   */
  getCategories(): { [key: string]: string } {
    return this.iconCategories;
  }

  /**
   * Retorna o caminho/referência de um ícone pelo valor
   */
  getIconPath(iconValue: string): string | null {
    const icon = this.allIconsSubject.value.find(i => i.value === iconValue);
    return icon ? icon.path : null;
  }

  /**
   * Retorna as chaves das categorias
   */
  getCategoryKeys(): string[] {
    return Object.keys(this.iconCategories);
  }
}
